import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface MapLayerGroupDialogData {
  title: string;
  hint?: string;
  name: string;
  confirmLabel: string;
  /** Returns an error message for a proposed name, or null when it is acceptable. */
  validate: (name: string) => string | null;
}

/** Name a new layer group or rename one: one field, Cancel and the primary action. */
@Component({
  selector: 'app-map-layer-group-dialog',
  templateUrl: './map-layer-group-dialog.component.html',
  styleUrls: ['./map-layer-group-dialog.component.scss'],
  standalone: false,
})
export class MapLayerGroupDialogComponent {
  name: string;
  error = '';

  constructor(
    private dialogRef: MatDialogRef<MapLayerGroupDialogComponent, string | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: MapLayerGroupDialogData,
  ) {
    this.name = data.name || '';
  }

  get canConfirm(): boolean { return !!this.name.trim(); }

  confirm(): void {
    const name = this.name.trim();
    if (!name) return;
    const error = this.data.validate(name);
    if (error) { this.error = error; return; }
    this.dialogRef.close(name);
  }

  dismiss(): void { this.dialogRef.close(undefined); }
}
